import { Accordion } from 'components/base'
import { Card } from 'components/Card/Card'
import React, { useState } from 'react'
import styled from 'styled-components'
const isMobile = window.innerWidth < 712

const StyledCardGrid = styled.div`
  font-family: var(--font-plex);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2px;
  grid-auto-flow: row;
  margin-bottom: 60px;

  position: relative;

  @media only screen and (max-width: 711px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const CardGrid = ({
  data,
  labels,
  showAll = false.valueOf(),
  lang = 'de'
}: {
  data: FruitElementType[]
  labels: (string | string[])[][]
  showAll?: boolean
  lang: 'de' | 'fr'
}) => {
  const [detailView, setDetailView] = useState<number | undefined>()
  const handleAccordionClose = () => {
    setDetailView(undefined)
  }
  const Grid = (
    <StyledCardGrid>
      {data.map((m, i) => {
        return (
          <Card
            key={'Key_ChartGrid_' + i}
            data={m}
            hasSeason={m.hasSeason || false}
            toggleOverlay={setDetailView}
            isActive={detailView == m.id}
            rowPosition={isMobile ? i % 2 : i % 4}
            lang={lang}
            labels={labels[1]}
          />
        )
      })}
    </StyledCardGrid>
  )
  if (showAll) return Grid
  return (
    <Accordion
      labels={labels[0]}
      heightClosed={340}
      handleClose={handleAccordionClose}
      lightButton
      data={data}
    >
      {Grid}
    </Accordion>
  )
}
